import { LOCALE_SET } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case LOCALE_SET:
      localStorage.setItem("locale", action.lang);
      return { ...state, lang: action.lang, messages: action.messages };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Locale.js